module.exports = __webpack_public_path__ + "static/media/logo-krowd-white.b4df0b33.svg";